
import { useState } from 'react'


const EmployeeCard = ({ name, avatar, title, certifications, text }) => {

    const [isOpen, setIsOpen] = useState(false)

    return (

        <>
            <button onClick={() => { setIsOpen(true) }}>
                <div className="w-full sm:max-w-[300px] max-w-full h-full bg-white border p-4 border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
                    <div className="flex sm:flex-row sm:gap-2 gap-6 flex-col items-center h-full w-full justify-center">
                        <img
                            className="sm:w-20 sm:h-20 w-24 h-24 rounded-full shadow-lg object-cover"
                            src={avatar}
                            alt={`img_${name}`}
                        />
                        <div className="flex flex-col w-full">
                            <h5 className="sm:text-xl text-md font-medium text-gray-900 dark:text-white">{name}</h5>
                            <span className="text-sm text-gray-500 dark:text-gray-400">{title}</span>
                        </div>
                    </div>
                </div>
            </button >
            {isOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-md" onClick={() => setIsOpen(false)}>
                    <div class="sm:max-w-md w-5/6 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
                        <img class="rounded-t-lg" src={avatar} alt="" />

                        <div class="p-5">

                            <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                                {name}
                            </h5>
                            <p className="text-sm text-gray-500 dark:text-gray-400">{title}</p>

                            <p class="mb-3 font-normal text-gray-900 dark:text-white">
                                {text}
                            </p>

                            <div className="flex flex-row justify-center">
                                {certifications.map((cert, index) => (
                                    <>
                                        <div className="flex flex-col">
                                            <img className="w-12 h-12 rounded-full mr-4" src={cert.logo}></img>
                                            {/* <p className="text-xs">{cert.name}</p> */}
                                        </div>
                                    </>
                                ))}
                            </div>
                        </div>
                    </div>


                </div>
            )
            }
        </>
    );
};

export default EmployeeCard;
